export function normalizeText(text) {
  return (text || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

export function getSearchVariants(word) {
  const base = normalizeText(word);
  const variants = new Set();

  variants.add(base);

  if (base.endsWith('s')) {
    variants.add(base.slice(0, -1));
  } else {
    variants.add(base + 's');
  }

  if (base.endsWith('is')) {
    variants.add(base.slice(0, -1));
    variants.add(base.slice(0, -2));
  }

  if (base.endsWith('oes')) {
    variants.add(base.replace('oes', 'ao'));
  }

  if (base.endsWith('ao')) {
    variants.add(base.replace('ao', 'oes'));
  }

  return Array.from(variants);
}
